export default "__VITE_ASSET__Bu2jIY$n__"